<template>
  <div id="register" class="register">
    <div class="registerTitle">
			<div class="registerTitle_logo" @click="toMenu('/home')"></div>
		</div>
    <div class="registerCont">
      <div class="registerCont_cont">
        <div class="registerCont_cont_cont">
          <div class="regisCon_left">
            <el-form size="small" :model="form" :rules="formRules" ref="orgDialogForm">
              <div class="regisCon_div"><i class="iconfont icon-denglu"></i>
                <el-form-item prop="email">
                  <el-input placeholder="邮箱号" v-model="form.email"></el-input>
                </el-form-item>
              </div>
              <div class="regisCon_div"><i class="iconfont icon-shouji"></i>
                <el-form-item prop="cell">
                  <el-input placeholder="手机号" v-model="form.cell"></el-input>
                </el-form-item>
              </div>
              <!-- <div class="regisCon_div"><i class="iconfont icon-securityCode-b"></i>
                <el-form-item prop="code">
                  <el-input placeholder="验证码" v-model="form.code"></el-input>
                </el-form-item>
                <div  class="regis_hq" size="small" @click="getCode" :class="{'closeClick':time!='获取验证码'}">{{time}}<span v-show="time!='获取验证码'">秒后重新获取</span></div>
              </div> -->
              <div class="regisCon_div"><i class="iconfont icon-mima"></i>
                <el-form-item prop="password">
                  <el-input placeholder="请输入密码" type="password" v-model="form.password"></el-input>
                </el-form-item>
              </div>
              <div class="regisCon_div"><i class="iconfont icon-mima"></i>
                <el-form-item prop="confirmPassword">
                  <el-input placeholder="再次输入密码" type="password" v-model="form.confirmPassword"></el-input>
                </el-form-item>
              </div>
              <div class="regisCon_div" style="width:230px;">
                <el-form-item prop="codeB">
                  <el-input placeholder="请输入图形验证码" v-model="form.codeB"></el-input>
                </el-form-item>
                <div class="regis_yzm" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </div>
              <div class="regisCon_div" style="border:none;">
                <el-form-item prop="checked">
                  <el-checkbox v-model="form.checked" disabled>我已阅读，理解并接受《注册协议》。</el-checkbox>
                </el-form-item>
              </div>
              <div class="regisCon_div" @click="register()"><a>注册</a></div>
            </el-form>
            <span class="moLogin"><router-link :to="{name:'login'}">已有账号，去登录<i class="iconfont icon-rightarrow"></i></router-link></span>
          </div>
        </div>
      </div>
    </div>
    <div class="registerFoot">
      © 中国 北京 2015.11      沪ICP备05015387号    互联网出版许可证
    </div>
  </div>
</template>

<script>
import util from '../../assets/script/util'
import SIdentify  from '../sidentify'
import axios from 'axios'
import validate from '../../assets/script/validate';
import router from '@/router/index'
import $ from 'jquery'
import { pagination } from '../../../src/assets/mixin/data-table'

export default {
  name:'register',
  data(){
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validateMobile(value)) {
        callback(new Error('手机号需为11位数字'));
      } else {
        callback();
      }
    };
    const VALIDATE_EMAIL = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validateEmail(value)) {
        callback(new Error('Email需合法'));
      } else {
        callback();
      }
    };
    const VALIDATE_PASSWORD = (rule, value, callback) => {
      if (util.isNotEmpty(value) && !validate.validatePassword(value)) {
        callback(new Error('密码需为6-20位字符'));
      } else {
        callback();
      }
    };
    const VALIDATE_CONFIRM_PASSWORD = (rule, value, callback) => {
      if (util.isNotEmpty(this.form.password)) {
        if (this.form.password === this.form.confirmPassword) {
          callback();
        } else {
          callback(new Error('两次密码输入不一致'));
        }
      } else {
        callback();
      }
    };
    return{
      time:"获取验证码",
      identifyCode:'',
      qwer:'',
      form:{
        email:'',
        cell:'',
        code:'',
        password:'',
        confirmPassword:'',
        codeB:'',
        checked:true
      },
      formRules: {
        cell: [{ validator: VALIDATE_MOBILE_NO, trigger: 'blur' }],
        email: [{ validator: VALIDATE_EMAIL, trigger: 'blur' }],
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {validator: VALIDATE_PASSWORD, trigger: 'blur' }
        ],
        confirmPassword: [
          {validator: VALIDATE_CONFIRM_PASSWORD, trigger: 'blur' }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'change'
          }
        ],
        codeB: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: 'change'
          }
        ],
        checked: [
          {
            required: true,
            message: '请勾选协议',
            trigger: 'change'
          }
        ],
      },
      identifyCodes: "1234567890",
      identifyCode: "",
    }
  },
  components:{
    SIdentify,
    // Header,
    // Navigation,
    // FootBase,
    // NaviRight,
    // JusTinTime,
    // Mosearch,
    // Mofoot
  },
  methods:{
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    toMenu(url){
      this.$router.push({
        path:url
      })
    },

    // /   /authorapi/reg //注册
// JournalID //期刊ID，固定201907260001
// LoginName //邮箱
// Pwd //密码
// RealName //姓名
// Mobile //手机
// Status //是否可用，设置成1
    register(){
      localStorage.setItem('cell', this.form.cell);
      this.clearCookie();
      if(this.identifyCode !== this.form.codeB){
        this.form.codeB = '';
        this.refreshCode();
        alert('请输入正确的验证码');
      }
      this.$refs.orgDialogForm.validate(valid => {
        if (valid) {
          axios.post('/authorapi/regapi',{
            JournalID:'202007100001',
            LoginName: this.form.email,
            Pwd: this.form.password,
            RealName:'注册用户',
            Mobile: this.form.cell
          }).then((res) => {
            if(res.data.Content = '000000'){
              this.$message({
                message: '注册成功',
                type: 'success'
              });
              this.$router.push({
                path: '/login'
              });
            } else {
              this.$message({
                message:'该邮箱已经注册，请直接登录',
                type:'error'
              });
            }
          }).catch(({ msg }) => {
            this.$message({
              type: 'error',
              message: msg
            });
          });
        } else {
          if (this.form.email == '') {
            this.$message({
              message: '请输入邮箱',
              type: 'warning'
            });
            return false;
          }
          if (this.form.cell == '') {
            this.$message({
              message: '请输入手机号',
              type: 'warning'
            });
            return false;
          }
          if (this.form.password == '') {
            this.$message({
              message: '请输入密码',
              type: 'warning'
            });
            return false;
          }   
          if (this.form.code == '') {
            this.$message({
              message: '请输入验证码',
              type: 'warning'
            });
            return false;
          }
          if (this.form.checked == '') {
            this.$message({
              message: '请勾选协议',
              type: 'warning'
            });
            return false;
          }
          if (this.form.codeB == '') {
            this.$message({
              message: '请输入图形验证码',
              type: 'warning'
            });
            return false;
          }
        }
      });
    },
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      console.log("cookie过期时间："+exdate);
      //字符串拼接cookie
      window.document.cookie =
        "c_name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "c_pwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    // 获取cookie
    getCookie: function(key) {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值            z   ,2
          // if (arr2[0] == "c_name") {
          //   this.form.email = arr2[1]; //保存到保存数据的地方
          // } else if (arr2[0] == "c_pwd") {
          //   this.form.password = arr2[1];
          // }
        }
      }
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    // 验证码
    gettime(){
      if(this.time == 0){
        clearInterval(this.close);
        this.time = '获取验证码';
      } else {
        this.time--;
      }
    },
    // 获取验证码
    getCode(){
      axios.get('/api/Lm/GetNoteVc?smsMob='+this.form.cell).then((res) => {
        if(res.status == 200){
          this.time = 60;
          this.close = setInterval(this.gettime,1000);
        } else {
          this.$message({
            message: '信息发送失败',
            type: 'warning'
          });
        }
      }).catch((e) => {
        console.log(e);
      })
    }

  },
  mounted(){
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  created(){
    this.refreshCode();
  }
}
</script>

<style lang="less" scoped>
  #register{
    width:100%;
    height:100%;
    .registerTitle{
			width:1200px;
			height:66px;
			margin:0 auto;
			margin-top:46px;
			.registerTitle_logo{
				float: left;
				width: 748px;
				height: 66px;
				margin-left: 30px;
				background: url('../../../static/logo.png')no-repeat;
        background-size: cover;
        cursor:pointer;
			}
		}
    .registerFoot{
      width: 335px;
      height: 15px;
      margin: 0 auto;
      position: relative;
      margin-top:29px;
    }
    .registerCont{
      width:100%;
      height:620px;
      background:#fff;
      position:relative;
      background:url('../../../static/注册页_02.png')no-repeat;
      background-size:cover;
      margin-top:28px;
      .registerCont_cont{
        width:1140px;
        height:100%;
        margin: 0 auto;
        position: relative;
        .registerCont_cont_cont{
          width:464px;
          height:494px;
          background:#fff;
          position:absolute;
          top:70px;
          right: 0;
        }
      }
      .regisCon_left{
        width:369px;
        height:405px;
        float:left;
        margin-left:66px;
        margin-top:45px;
        .regisCon_div{
          width:332px;
          height:37px;
          border:1px solid #CBCBCB;
          margin-bottom:17px;
          border-radius:5px;
          position: relative;
          .regis_hq{
            width: 92px;
            height:35px;
            background:#C01B22;
            line-height:35px;
            text-align:center;
            color:#fff;
            font-size:16px;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 0;
            border-radius:0 5px 5px 0;
          }
          .regis_yzm{
            width: 92px;
            height: 35px;
            cursor: pointer;
            right: -104px;
            top: 0;
            position: absolute;
            em{
              letter-spacing: 6px;
            }
          }
          i{
            color:#CBCBCB;
            font-size:20px;
            position: relative;
            top: 3px;
            margin-left:19px;
          }
        }
        // .regisCon_div:nth-child(7){
        //   line-height: 15px;
        //   text-align: center;
        //   height:15px;
        //   color:#656565;
        //   font-size:14px;
        //   border:none;
        // }
        .regisCon_div:last-child{
          background: #DFDFDF;
          text-align: center;
          line-height: 37px;
          margin-top:39px;
          cursor: pointer;
          a{
            color:#898989;
            font-size:18px;
          }
        }
        .regisCon_div:last-child:hover{
          background: #C01B22;
          a{
            color: #fff;
          }
        }
      }
    }
  }
  .closeClick {
    pointer-events: none;
  }
  /deep/.el-input__inner{
    height:35px!important;
    line-height:35px!important;
    border:none;
  }
  /deep/.el-form-item{
    width:86%;
    position: absolute;
    left: 46px;
    top: 0;
  }
  /deep/.el-form-item__content{
    line-height:34px;
  }
  /deep/.el-input{
    width: 87%;
    outline:none;
    border:none;
  }
  .moLogin{
    a{
      color: #C01B22;
      font-size:14px;
      float: right;
      margin-right: 40px;
      i{
        font-size: 14px;
        color: #C01B22;
        margin-left: 11px;
      }
    }
  }

  @media screen and (min-width:1010px){
    .moLogin{
      // display: none;
    }
  }

  @media screen and (max-width:1010px){
    .registerTitle{
      display: none;
    }
    .moLogin{
      position:relative;
      position: absolute;
      right: 0;
      a{
        color: #C0C4CC;
        font-size: 15px;
        i{
          margin-left: 5px;
        }
      }
    }
    #register .registerCont .regisCon_left .regisCon_div:last-child{
      background: #C01B22;
      a{
        color: #fff;
      }
    }
    #mofootBase{
      margin-top: 65px;
    }
    .registerFoot{
      display: none;
    }
    .registerCont{
      position: relative;
      top: 50px;
      background: #fff!important;
      height:480px!important;
      .registerCont_cont{
        width: 100%!important;
        .registerCont_cont_cont{
          width: 83%!important;
          top: 0px!important;
          height: auto!important;
          margin: 0 auto;
          position: relative!important;
          .regisCon_left{
            width: 100%!important;
            float: none!important;
            margin-left: 0!important;
            border: none!important;
            .el-form{
              width: 100%!important;
              .regisCon_div{
                width: 100%!important;
              }
              .regisCon_div:nth-child(6){
                width: 183px!important;
                .el-form-item{
                  width: 100%!important;
                  left: 0!important;
                }
              }
            }
          }
          .regisCon_right{
            display:none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/register/index.vue